import { render } from "./App.vue?vue&type=template&id=4d5c59a6&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=4d5c59a6&lang=less"

import exportComponent from "D:\\jproject\\rena\\renar\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__